import useUser from "state/User/useUser";
import { ROLE_CANDIDATE_EPG } from "utils/ConstantsAndNum";

const useRoleActive = () => {
    const { user } = useUser();
    
    return {
        isRoleEPG: user?.role === ROLE_CANDIDATE_EPG.toUpperCase(),
    }
};

export default useRoleActive;